import React from 'react';
import { FooterLink } from './FooterLink';
import { useAuthentication } from '../../Login/hooks/useAuthentication';

export const Footer: React.FC = () => {
    const { isAuthenticated } = useAuthentication();
    const copyrightMessage = '© 2025 Builder Finance. All rights reserved.';
    const phoneNumber = '800-752-0401';
    const footerLinkClass = () => {
        return `footerNav-link ${isAuthenticated ? 'authenticated' : ''}`;
    };

    const termsOfServiceLink = () => {
        return (
            <FooterLink
                url='https://www.builderfinance.com/en/site-terms'
                className={footerLinkClass()}
            >
                Terms of Service
            </FooterLink>
        );
    };

    const privacyPolicyLink = () => {
        return (
            <FooterLink
                url='https://www.builderfinance.com/en/privacy-policy'
                className={footerLinkClass()}
            >
                Privacy Policy
            </FooterLink>
        );
    };

    return (
        <>
            <footer className={`${isAuthenticated ? 'authenticated' : ''}`}>
                {isAuthenticated ? (
                    <div className='footerContainer'>
                        <div className={`corporateWrapper ${isAuthenticated ? 'authenticated' : ''}`}>
                            <a
                                href='/'
                                className='logo no-print'
                            >
                                <img
                                    src='/assets/img/footer-logo.png'
                                    alt='Builder Finance'
                                    width={'150px'}
                                />
                            </a>
                            <br />
                            <p className='corporateWrapper-disclaimer'>
                                Loans in the Draw section are not fully funded, but may or may not be eligible for draws
                            </p>
                            <p className='corporateWrapper-disclaimerrights'>{copyrightMessage}</p>
                        </div>
                        <div className={`footerNav ${isAuthenticated ? 'authenticated' : ''}`}>
                            <div className='footerNav-linklist'>{termsOfServiceLink()}</div>
                            <div className='footerNav-linklist'>{privacyPolicyLink()}</div>
                            <div className='footerContact'>
                                <p>
                                    <b>Phone:</b> {phoneNumber}
                                </p>
                            </div>
                        </div>
                    </div>
                ) : (
                    <div className='footerContainer'>
                        <div className={`corporateWrapper ${isAuthenticated ? 'authenticated' : ''}`}>
                            <p className='corporateWrapper-disclaimerrights'>{copyrightMessage}</p>
                        </div>
                        <div className={`footerNav ${isAuthenticated ? 'authenticated' : ''}`}>
                            <span style={{ paddingRight: '5px' }}>{termsOfServiceLink()}</span> |
                            <span style={{ paddingLeft: '5px', paddingRight: '5px' }}>{privacyPolicyLink()}</span> |
                            <span style={{ paddingLeft: '5px' }}>
                                <b>Phone:</b>
                                <span style={{ color: '#112CA0', paddingLeft: '3px' }}>{phoneNumber}</span>
                            </span>
                        </div>
                    </div>
                )}
            </footer>
        </>
    );
};
